import progressGr16_202307 from '../reports/progress-gr1-6-2023-07/index.js'
import progressGr78_202307 from '../reports/progress-gr7-8-2023-07/index.js'
import provincialGr16_202309 from '../reports/provincial-gr1-6-2023-09/index.js'
import provincialGr78_202309 from '../reports/provincial-gr7-8-2023-09/index.js'

const REGISTRY = {
  [progressGr16_202307.key]: progressGr16_202307,
  [progressGr78_202307.key]: progressGr78_202307,
  [provincialGr16_202309.key]: provincialGr16_202309,
  [provincialGr78_202309.key]: provincialGr78_202309,
}

export async function generatePdf(reportTypeKey, formData, options = {}) {
  const entry = REGISTRY[reportTypeKey]
  if (!entry) throw new Error(`Unknown report type: ${reportTypeKey}`)
  return entry.fill(formData, options)
}

export function getTemplateUrl(reportTypeKey) {
  return REGISTRY[reportTypeKey]?.templateUrl
}
